module.exports = __webpack_public_path__ + "static/Les Joies De L'Ivresse-24f634f89b88f5191c9b24fa13381fc9.mp3";